import React from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  CardSubtitle,
} from "reactstrap"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "../../../src/assets/scss/datatables.scss"

export default function LastMinuteDeal() {
  const data = {
    columns: [
      {
        label: "Product",
        field: "ProductName",
        sort: "asc",
        attributes: {width:"24%"},
      },
      {
        label: "Product Pack Size",
        field: "ProductPackSize",
        sort: "asc",
        attributes: {width:"17%"},
      },
      {
        label: "Discount",
        field: "Discount",
        sort: "asc",
        attributes: {width:"10%"},
      },
      {
        label: "Start Time",
        field: "StartTime",
        sort: "asc",
        attributes: {width:"17%"},
      },
      {
        label: "End Time",
        field: "EndTime",
        sort: "asc",
        attributes: {width:"17%"},
      },
      {
        label: "Assign Role",
        field: "AssignRole",
        sort: "asc",
        attributes: {width:"1   %"},
      },
    ],
    rows: [
      {
        ProductName: "Pista",
        ProductPackSize: "100 GM",
        Discount: "15%",
        StartTime: "00:00",
        EndTime: "23:59",
        AssignRole: (
          <>
            <Link
              to={{
                pathname: "/",
              }}
            >
              <Button
                className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
                style={{ width: "25px", height: "25px", padding: "0px" }}
                title="Edit"
                onClick={() => {}}
              >
                <i className="fas fa-edit"></i>
              </Button>
            </Link>
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Delete"
              onClick={() => {}}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </Button>{" "}
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary"
              style={{
                width: "25px",
                height: "25px",
                padding: "0px",
              }}
              title="Active / Inactive"
              onClick={() => {}}
            >
              <i className="fas fa-bullseye" style={{ color: "#38e038" }}></i>
            </Button>
          </>
        ),
      },
    ],
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Last Minute Deal | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}

          <Button
            href="/add-LastMinuteDeal"
            color="primary"
            style={{ float: "right", marginTop: "1.9rem" }}
          >
            Add Last Minute Deal
          </Button>
 
          <Breadcrumbs
            maintitle="Dashboard"
            title="Last Minute Deal"
            breadcrumbItem="Last Minute Deal"
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable responsive bordered noBottomColumns theadColor="btn-primary" data={data} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
